import { render, staticRenderFns } from "./menu-lateral.html?vue&type=template&id=5e40fb47&scoped=true&"
import script from "./menu-lateral.js?vue&type=script&lang=js&"
export * from "./menu-lateral.js?vue&type=script&lang=js&"
import style0 from "./menu-lateral.css?vue&type=style&index=0&id=5e40fb47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40fb47",
  null
  
)

export default component.exports